import { render, staticRenderFns } from "./StoreRepair.vue?vue&type=template&id=a67b61d6&scoped=true&"
import script from "./StoreRepair.vue?vue&type=script&lang=ts&"
export * from "./StoreRepair.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67b61d6",
  null
  
)

export default component.exports